import { AUTH_ERROR_CODES, HARD_LOGOUT_401_CODES } from 'constants/auth.constant'

export const isForbiddenAuthz = (status, code) => status === 403 && code === AUTH_ERROR_CODES.FORBIDDEN

export const shouldAttemptRefresh = ({ status, code, isRetryRequest, isRefreshCall, skipAuthRefresh }) => (
    status === 401
    && code === AUTH_ERROR_CODES.TOKEN_EXPIRED
    && !isRetryRequest
    && !isRefreshCall
    && !skipAuthRefresh
)

export const shouldSkipGlobalAuthHandling = ({ isLoginCall, isRefreshCall }) => (
    isLoginCall || isRefreshCall
)

export const shouldForceLogout = ({ status, code, isRefreshCall, isLoginCall }) => (
    status === 401
    && !shouldSkipGlobalAuthHandling({ isLoginCall, isRefreshCall })
    && (HARD_LOGOUT_401_CODES.has(code) || !code)
)
